import { FC, PropsWithChildren } from 'react'

import { Icon } from '~/src/components/generic/PhosphorIcons'
import IconButton from '~/src/components/generic/IconButton'

import { tw } from '~/lib/utils'

type Props = {
  ariaLabel?: string
  className?: string
  content?: string
  onClose?: () => void
}

/**
 * SearchPill component to render content of applied search filter
 * @param {string} ariaLabel - ARIA label for accessibility.
 * @param {string} className - Additional CSS classes to apply to the pill.
 * @param {string} content - The content to be displayed inside the pill.
 * @param {function} onClose - Callback function to be called when the close button is clicked.
 * @returns
 */

const SearchPill: FC<PropsWithChildren<Props>> = ({
  ariaLabel,
  children,
  className,
  content,
  onClose,
}) => {
  return (
    <div
      className={tw(
        'flex items-center space-x-2 rounded border border-[#E8E8EA] px-2 py-1 text-body-m',
        className
      )}
      data-testid="search-pill"
    >
      {children}
      {content && <div>{content}</div>}
      {onClose && (
        <IconButton aria-label={ariaLabel} variant="ghost" onClick={onClose}>
          <Icon name="XIcon" size="16" />
        </IconButton>
      )}
    </div>
  )
}

export default SearchPill
